import React from 'react';
import { useHistory } from 'react-router-dom';
import { BackButton } from './styles';
import { Text } from '../Typography/Text';

export const GoBack = () => {
  const history = useHistory();
  return <BackButton onClick={() => history.goBack()}><Text size={18}>Back</Text></BackButton>;
};
